import logo from './logo.svg';
import './App.css';
import SiteVitrine from './pages/SiteVitrine'; 
import Login from './pages/Login'; 
import Dashboard from './pages/Dashboard'; 
import ValidationCompte from './pages/ValidationCompte'; 
import ResetPassword from './pages/ResetPassword'; 
import PublicRoutes from './pages/PublicRourtes'; 
import ProtectedRoutes from './pages/PrivateRoutes'; 
import Preinscription from './pages/Preinscription'; 
import { BrowserRouter, Route, Routes } from 'react-router-dom';
function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/" element = {<SiteVitrine/>}></Route>
      {/* <Route path="/login" element={<Login />} /> */}

      <Route path="/login" element={<PublicRoutes><Login /></PublicRoutes>}
      />
      {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        <Route path="/dashboard" element={<ProtectedRoutes> <Dashboard /> </ProtectedRoutes> } />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/preinscription" element={<Preinscription />} />
      <Route path="/validation-compte" element={<ValidationCompte />} />
    </Routes>
    </BrowserRouter>
  );
}

export default App;
